import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownOptionComponent } from './dropdown-option/dropdown-option.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { DropdownCategoryComponent } from './dropdown-category/dropdown-category.component';
import { UiIconModule } from '@cigna/ui/icon';

@NgModule({
  imports: [CommonModule, UiIconModule],
  declarations: [
    DropdownOptionComponent,
    DropdownComponent,
    DropdownCategoryComponent,
  ],
  exports: [
    DropdownOptionComponent,
    DropdownComponent,
    DropdownCategoryComponent,
  ],
})
export class UiDropdownModule {}
